import {
  put, takeLatest, all, select, takeEvery,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import JobWorkActions, { jobWorkActionTypes } from '@Actions/production/jobWorkActions';
import JobWorkServices from '../../services/production/jobWorkServices';

/**
 * @param action
 */
function* _getJobWorks(action) {
  try {
    yield put(JobWorkActions.getJobWorksLoading(true));
    const { payload, callback } = action;
    const {
      orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen,
    } = payload;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let jobWorks;
    if (isV2Enabled) {
      jobWorks = yield JobWorkServices.getJobWorksV2(orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen);
    } else {
      jobWorks = yield JobWorkServices.getJobWorks(orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen);
    }
    yield put(JobWorkActions.getJobWorksSuccess(jobWorks));
    yield put(JobWorkActions.getJobWorksLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorksLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.JOB_WORKS.ERROR, error));
  }
}

/**
 *
 */
function* getJobWorks() {
  yield takeLatest(jobWorkActionTypes.JOB_WORKS.REQUEST, _getJobWorks);
}

function* _getJobWorkById(action) {
  try {
    yield put(JobWorkActions.getJobWorkByIdLoading(true));
    const {
      payload, callback,
    } = action;
    const { tenantId, productionRouteLineId } = payload;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let jobWork;
    if (isV2Enabled) {
      jobWork = yield JobWorkServices.getJobWorkByIdV2(tenantId, productionRouteLineId);
    } else {
      jobWork = yield JobWorkServices.getJobWorkById(tenantId, productionRouteLineId);
    }
    if (jobWork?.success) {
      yield put(JobWorkActions.getJobWorkByIdSuccess(isV2Enabled ? jobWork?.job_works?.[0] : jobWork?.data?.job_works?.[0]));
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: jobWork.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.getJobWorkByIdLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorkByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getJobWorkById() {
  yield takeLatest(jobWorkActionTypes.JOB_WORK_BY_ID.REQUEST, _getJobWorkById);
}

/**
 * @param action
 */
function* _getJobWorkByMoId(action) {
  try {
    yield put(JobWorkActions.getJobWorkByMoIdLoading(true));
    const {
      orgId, tenantId, moId, isListScreen,
    } = action;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let jobWork;
    if (isV2Enabled) {
      jobWork = yield JobWorkServices.getJobWorkByMoIdV2(orgId, tenantId, moId, isListScreen);
    } else {
      jobWork = yield JobWorkServices.getJobWorkByMoId(orgId, tenantId, moId, isListScreen);
    }

    yield put(JobWorkActions.getJobWorkByMoIdSuccess(isV2Enabled ? jobWork : jobWork?.data));
    yield put(JobWorkActions.getJobWorkByMoIdLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorkByMoIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.JOB_WORK_BY_MO_ID.ERROR, error));
  }
}

/**
 *
 */
function* getJobWorkByMoId() {
  yield takeLatest(jobWorkActionTypes.JOB_WORK_BY_MO_ID.REQUEST, _getJobWorkByMoId);
}

function* _updateJobWork(action) {
  try {
    yield put(JobWorkActions.updateJobWorkLoading(true));
    const {
      payload, callback,
    } = action;
    const updatedJobwork = yield JobWorkServices.updateJobWork(payload);
    if (updatedJobwork?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        duration: 4,
        message: updatedJobwork?.error,
        type: 'error',
      });
    }
    yield put(JobWorkActions.updateJobWorkLoading(false));
  } catch (error) {
    yield put(JobWorkActions.updateJobWorkLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.UPDATE_JOB_WORK.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* updateJobWork() {
  yield takeLatest(jobWorkActionTypes.UPDATE_JOB_WORK.REQUEST, _updateJobWork);
}

function* _updateJobWorkV2(action) {
  try {
    yield put(JobWorkActions.updateJobWorkV2Loading(true));
    const {
      payload, callback,
    } = action;
    const updatedJobworkV2 = yield JobWorkServices.updateJobWorkV2(payload);
    if (updatedJobworkV2?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        duration: 4,
        message: updatedJobworkV2?.error,
        type: 'error',
      });
    }
    yield put(JobWorkActions.updateJobWorkV2Loading(false));
  } catch (error) {
    yield put(JobWorkActions.updateJobWorkV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.UPDATE_JOB_WORK_V2.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* updateJobWorkV2() {
  yield takeLatest(jobWorkActionTypes.UPDATE_JOB_WORK_V2.REQUEST, _updateJobWorkV2);
}

function* _getJobOperators(action) {
  try {
    yield put(JobWorkActions.getJobOperatorsLoading(true));
    const {
      payload,
    } = action;
    const jobOperators = yield JobWorkServices.getJobOperators(payload?.orgId);
    yield put(JobWorkActions.getJobOperatorsSuccess(jobOperators?.data?.[0]?.users));
    yield put(JobWorkActions.getJobOperatorsLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorkByMoIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.JOB_WORK_BY_MO_ID.ERROR, error));
  }
}

function* getJobOperators() {
  yield takeLatest(jobWorkActionTypes.GET_JOB_OPERATORS.REQUEST, _getJobOperators);
}

function* _getKanbanJobWorks(action) {
  const { payload, callback } = action;
  const {
    groupBy, tenantIds, orgId, status, page, limit, userIds, startDate, endDate, departmentId, searchKeyword, moStatus, resourceId, resourceGroupId,
  } = payload;
  try {
    yield put(JobWorkActions.getJobWorksKanbanLoading(true));
    const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, tenantIds, orgId, status, page, limit, userIds, startDate, endDate, departmentId, searchKeyword, moStatus, resourceId, resourceGroupId);
    if (jobWorks?.success) {
      yield put(JobWorkActions.getJobWorksKanbanSuccess(groupBy, jobWorks?.data));
      if (callback) {
        callback();
      }
      yield put(JobWorkActions.getJobWorksKanbanLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: jobWorks.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(JobWorkActions.getJobWorksKanbanLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.GET_JOB_WORK_KANBAN.ERROR, error));
  }
}

function* getKanbanJobWorks() {
  yield takeLatest(jobWorkActionTypes.GET_JOB_WORK_KANBAN.REQUEST, _getKanbanJobWorks);
}

function* _getKanbanJobWorksPage(action) {
  const { payload, callback } = action;
  const {
    groupBy, groupId, scrollType, reset,
  } = payload;
  const state = yield select();
  const groupDetails = state.JobWorkReducers?.kanbanJobWorks?.[groupBy];
  const { filters } = groupDetails;
  try {
    yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, true));
    if (groupBy === 'operator') {
      const groupToUpdate = groupDetails?.job_works?.find((item) => item?.group_name === groupId?.replaceAll('column-', ''));
      const pageUserId = groupToUpdate?.job_works?.[0]?.assignees?.[0]?.user_id || '-1000';
      const count = Number(groupToUpdate?.count);
      const { page, limit, group_name } = groupToUpdate;
      if (count > (limit * page) || reset) {
        const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, filters?.tenant_id, filters?.org_id, filters?.status, reset ? 1 : page + 1, filters?.limit, pageUserId?.toString(), filters?.from_date, filters?.to_date, filters?.department_id, filters?.search_keyword, filters?.mo_status, filters?.resource_id, filters?.resource_group_id);
        if (jobWorks?.success) {
          yield put(JobWorkActions.getJobWorksKanbanPageSuccess(groupBy, jobWorks?.data?.job_works?.filter((item) => item?.group_name?.includes(group_name))?.[0]?.job_works, reset ? 0 : page, reset ? 1 : page + 1, group_name, jobWorks?.data?.job_works?.filter((item) => item?.group_name?.includes(group_name))?.[0]?.count));
          if (callback) {
            callback();
          }
        } else {
          notification.open({
            type: 'error',
            message: jobWorks.message,
            duration: 4,
            placement: 'top',
          });
        }
      }
      yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, false));
    } else if (groupBy === 'machine' || reset) {
      const groupToUpdate = groupDetails?.job_works?.find((item) => item?.group_name === groupId?.replaceAll('column-', ''));
      const pageMachineId = groupToUpdate?.job_works?.[0]?.machine_resource_group?.allocated_machine?.resource_id;
      const count = Number(groupToUpdate?.count);
      const { page, limit, group_name } = groupToUpdate;
      if (count > (limit * page)) {
        const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, filters?.tenant_id, filters?.org_id, filters?.status, page + 1, filters?.limit, filters?.user_id, filters?.from_date, filters?.to_date, filters?.department_id, filters?.search_keyword, filters?.mo_status, pageMachineId, filters?.resource_group_id);
        if (jobWorks?.success) {
          yield put(JobWorkActions.getJobWorksKanbanPageSuccess(groupBy, jobWorks?.data?.job_works?.[0]?.job_works, page, page + 1, group_name, jobWorks?.data?.job_works?.[0]?.count));
          if (callback) {
            callback();
          }
        } else {
          notification.open({
            type: 'error',
            message: jobWorks.message,
            duration: 4,
            placement: 'top',
          });
        }
      }
    } else if (groupBy === 'work_center' || reset) {
      const groupToUpdate = groupDetails?.job_works?.find((item) => item?.group_name === groupId?.replaceAll('column-', ''));
      const pageResourceGroupId = groupToUpdate?.job_works?.[0]?.machine_resource_group?.resource_group_id;
      const count = Number(groupToUpdate?.count);
      const { page, limit, group_name } = groupToUpdate;
      if (count > (limit * page)) {
        const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, filters?.tenant_id, filters?.org_id, filters?.status, page + 1, filters?.limit, filters?.user_id, filters?.from_date, filters?.to_date, filters?.department_id, filters?.search_keyword, filters?.mo_status, filters?.resource_id, pageResourceGroupId);
        if (jobWorks?.success) {
          yield put(JobWorkActions.getJobWorksKanbanPageSuccess(groupBy, jobWorks?.data?.job_works?.[0]?.job_works, page, page + 1, group_name, jobWorks?.data?.job_works?.[0]?.count));
          if (callback) {
            callback();
          }
        } else {
          notification.open({
            type: 'error',
            message: jobWorks.message,
            duration: 4,
            placement: 'top',
          });
        }
      }
    }
    yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* _getMasterProductionProcessKanban(action) {
  const { payload, callback } = action;
  try {
    yield put(JobWorkActions.getMasterProductionProcessKanbanLoading(true));
    const masterProductionProcessKanban = yield JobWorkServices.getMasterProductionProcessKanban(payload);
    if (masterProductionProcessKanban?.success) {
      yield put(JobWorkActions.getMasterProductionProcessKanbanSuccess(payload?.groupBy, masterProductionProcessKanban));
      if (callback) {
        callback();
      }
      yield put(JobWorkActions.getMasterProductionProcessKanbanLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: masterProductionProcessKanban.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(JobWorkActions.getMasterProductionProcessKanbanLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.ERROR, error));
  }
}

function* getMasterProductionProcessKanban() {
  yield takeLatest(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.REQUEST, _getMasterProductionProcessKanban);
}

function* _getMasterProductionProcessKanbanPage(action) {
  const { payload, callback } = action;
  const {
    groupBy, groupName,
  } = payload;
  const state = yield select();
  const groupDetails = state.JobWorkReducers?.masterProductionProcessKanban?.[groupBy];
  const { filters } = groupDetails;
  try {
    yield put(JobWorkActions.getMasterProductionProcessKanbanPageLoading(groupBy, true));
    const groupToUpdate = groupDetails?.master_production_processes?.find((item) => item?.group_name === groupName?.replaceAll('column-', ''));
    const count = Number(groupToUpdate?.count);
    const { page, limit, group_name } = groupToUpdate;
    let groupId;
    if (groupBy === 'machine') groupId = groupToUpdate?.machine_id;
    if (groupBy === 'work_center') groupId = groupToUpdate?.work_center_id;
    if (groupBy === 'finished_good') groupId = groupToUpdate?.product_sku_id;
    if (count > (limit * page)) {
      const masterProductionProcess = yield JobWorkServices.getMasterProductionProcessKanban({ ...filters, page: page + 1, groupBy, groupName, groupId });
      if (masterProductionProcess?.success) {
        yield put(JobWorkActions.getMasterProductionProcessKanbanPageSuccess(groupBy, masterProductionProcess?.data?.[0].master_production_process, page, page + 1, group_name, masterProductionProcess?.data?.[0].count));
        if (callback) {
          callback();
        }
      } else {
        notification.open({
          type: 'error',
          message: masterProductionProcess.message,
          duration: 4,
          placement: 'top',
        });
      }
    }
    yield put(JobWorkActions.getMasterProductionProcessKanbanPageLoading(groupBy, false));
  } catch (error) {
    yield put(JobWorkActions.getMasterProductionProcessKanbanPageLoading(groupBy, false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getMasterProductionProcessKanbanPage() {
  yield takeEvery(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE.REQUEST, _getMasterProductionProcessKanbanPage);
}

function* _getSubJobCardsKanban(action) {
  const { payload, callback } = action;
  try {
    yield put(JobWorkActions.getSubJobCardsKanbanLoading(true));
    const subJobCards = yield JobWorkServices.getSubJobCardsKanban(payload);
    if (subJobCards?.success) {
      yield put(JobWorkActions.getSubJobCardsKanbanSuccess(payload?.groupBy, subJobCards?.data));
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: subJobCards.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(JobWorkActions.getSubJobCardsKanbanLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getSubJobCardsKanbanLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getSubJobCardsKanban() {
  yield takeLatest(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN.REQUEST, _getSubJobCardsKanban);
}

function* _getSubJobCardsKanbanPage(action) {
  const { payload, callback } = action;
  const {
    groupBy, groupName,
  } = payload;
  const state = yield select();
  const groupDetails = state.JobWorkReducers?.subJobCardsKanban?.[groupBy];
  const { filters } = groupDetails;
  try {
    yield put(JobWorkActions.getSubJobCardsKanbanPageLoading(groupBy, true));
    const groupToUpdate = groupDetails?.sub_job_cards?.find((item) => item?.group_name === groupName?.replaceAll('column-', ''));
    const count = Number(groupToUpdate?.count);
    const { page, limit, group_name } = groupToUpdate;
    let groupId;
    if (groupBy === 'machine') groupId = groupToUpdate?.resource_id;
    if (groupBy === 'work_center') groupId = groupToUpdate?.resource_group_id;
    if (groupBy === 'finished_good') groupId = groupToUpdate?.product_sku_id;
    if (groupBy === 'operator') groupId = groupToUpdate?.operator_id;
    if (count > (limit * page)) {
      const subJobCards = yield JobWorkServices.getSubJobCardsKanban({ ...filters, page: page + 1, groupBy, groupName, groupId });
      if (subJobCards?.success) {
        yield put(JobWorkActions.getSubJobCardsKanbanPageSuccess(groupBy, subJobCards?.data?.sub_job_works[0]?.sub_job_work, page, page + 1, group_name, subJobCards?.data?.sub_job_works[0]?.count));
        if (callback) {
          callback();
        }
      } else {
        notification.open({
          type: 'error',
          message: subJobCards.message,
          duration: 4,
          placement: 'top',
        });
      }
    }
    yield put(JobWorkActions.getSubJobCardsKanbanPageLoading(groupBy, false));
  } catch (error) {
    yield put(JobWorkActions.getSubJobCardsKanbanPageLoading(groupBy, false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getSubJobCardsKanbanPage() {
  yield takeEvery(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN_PAGE.REQUEST, _getSubJobCardsKanbanPage);
}

function* getKanbanJobWorksPage() {
  yield takeEvery(jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.REQUEST, _getKanbanJobWorksPage);
}

function* _processJwMaterial(action) {
  try {
    yield put(JobWorkActions.processJwMaterialLoading(true));
    const {
      payload, callback,
    } = action;
    const response = yield JobWorkServices.processJwMaterial(payload);
    if (response?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: response?.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.processJwMaterialLoading(false));
  } catch (error) {
    yield put(JobWorkActions.processJwMaterialLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* _processJwMaterialComplete(action) {
  try {
    yield put(JobWorkActions.processJwMaterialCompleteLoading(true));
    const {
      payload, callback,
    } = action;
    const response = yield JobWorkServices.processJwMaterialComplete(payload);
    if (response?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: response?.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.processJwMaterialCompleteLoading(false));
  } catch (error) {
    yield put(JobWorkActions.processJwMaterialCompleteLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }

}

function* processJwMaterialComplete() {
  yield takeLatest(jobWorkActionTypes.PROCESS_JW_MATERIAL_COMPLETE.REQUEST, _processJwMaterialComplete);
}

function* processJwMaterial() {
  yield takeLatest(jobWorkActionTypes.PROCESS_JW_MATERIAL.REQUEST, _processJwMaterial);
}

function* _getMasterProductionProcessList(action) {
  try {
    yield put(JobWorkActions.getMasterProductionProcessListLoading(true));
    const { payload, callback } = action;
    const masterProductionProcessList = yield JobWorkServices.getMasterProductionProcessList(payload);
    yield put(JobWorkActions.getMasterProductionProcessListSuccess(masterProductionProcessList));
    if (masterProductionProcessList?.success) {
      if (callback) {
        callback(masterProductionProcessList);
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: masterProductionProcessList?.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.getMasterProductionProcessListLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getMasterProductionProcessListLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to fetch Master Production Process List',
      duration: 4,
      placement: 'top',
    });
  }
}

function* getMasterProductionProcessList() {
  yield takeLatest(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_LIST.REQUEST, _getMasterProductionProcessList);
}

function* _getSubJobCardsList(action) {
  try {
    yield put(JobWorkActions.getSubJobCardsListLoading(true));
    const { payload, callback } = action;
    const subJobCards = yield JobWorkServices.getSubJobCardsList(payload);
    yield put(JobWorkActions.getSubJobCardsListSuccess(subJobCards));
    if (subJobCards?.success) {
      if (callback) {
        callback(subJobCards);
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: subJobCards?.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.getSubJobCardsListLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getSubJobCardsListLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to fetch Sub Job Cards List',
      duration: 4,
      placement: 'top',
    });
  }
}

function* getSubJobCardsList() {
  yield takeLatest(jobWorkActionTypes.GET_SUB_JOB_CARDS_LIST.REQUEST, _getSubJobCardsList);
}
/**
 *
 */
export default function* jobWorkSaga() {
  yield all([
    getJobWorks(),
    getJobWorkById(),
    getJobWorkByMoId(),
    updateJobWork(),
    updateJobWorkV2(),
    getJobOperators(),
    getKanbanJobWorks(),
    getKanbanJobWorksPage(),
    processJwMaterial(),
    processJwMaterialComplete(),
    getMasterProductionProcessList(),
    getSubJobCardsList(),
    getMasterProductionProcessKanban(),
    getMasterProductionProcessKanbanPage(),
    getSubJobCardsKanban(),
    getSubJobCardsKanbanPage(),
  ]);
}
